<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="options"
            :class="validateError != '' ? 'box-border-color' : ''"
            @input="onSelectChange($event)"
            label="text"
            @change="onSelectChange($event)"
            track-by="value"
            :multiple="multiple"
            :close-on-select="!multiple"
            :clear-on-select="!multiple"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
        >
            <template slot="selection" slot-scope="{ values, search, isOpen }" v-if="multiple">
                <span class="multiselect__single" v-if="values.length && !isOpen">
                    {{ translateNSelected(values) }}
                </span>
            </template>
            <span slot="noOptions">{{ $t("no_options") }}</span>
            <span slot="noResult">{{ $t("no_result") }}</span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError"
        />
    </div>
</template>

<script>
// Helpers
import translateNSelected from "@/helpers/translateNSelected";
import setSelected from "@/helpers/setSelected";

// Services
import GradeService from "@/services/GradeService";

export default {
    props: {
        value: {
            default: null,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        validateError: {
            type: String,
            default: "",
        },
    },
    watch: {
        value: {
             handler(newValue){
                 this.selected = this.setSelected(newValue, this.options, this.multiple)
             }
        }
    },
    data() {
        return {
            type:null,
            selected: null,
            options: [],
        };
    },
    created() {
        this.getOptions();
    },
    methods: {
        translateNSelected: translateNSelected,
        setSelected: setSelected,
        onSelectChange(eventValue) {
            this.$emit('input', eventValue.value)
            if (eventValue) {
                const selectedType = this.multiple
                    ? eventValue.map(v => v.type)
                    : eventValue.type;
                this.$emit('type-changed', selectedType);
            } else {
                this.$emit('type-changed', null);
            }
        },

        getOptions() {
            const config = {
                params: {
                    limit: -1,
                },
            };
            GradeService.getGradeSystems(config)
                .then((response) => {
                    const data = response.data.data;
                    const newOptions = data.map((item) => ({
                        value: item.id,
                        text: this.getLocaleText(item, 'name'),
                        type: item.type
                    }));
                    this.options = newOptions;
                })
                .then(() => {
                    this.selected = this.setSelected(this.value, this.options, this.multiple)
                })
        }
    }
}
</script>
